import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import { ICONS } from '@Const/common'
import Button from '@Components/Buttons/Button'
import ModalPortal from '@Components/Popups/ModalPortal'
import Sidebar from '@Components/Sidebars/Sidebar'
import AddNewUserSub from '@Components/AddNewUserSub'
import MaintenanceMobileSubLinks from '@Components/Navigations/MaintenanceMobileSubLinks'
import { StoresContext } from '@App/contexts'
import ContentHeader from '@Components/ContentHeader'
import UserPermissionsContentHeader from '@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissions/UserPermissionsContentHeader'
import RightsholderUserPermissionsUsersList from '@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissions/RightsholderUserPermissionsUsersList'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'

const RightsholderMaintenanceUserPermissions = () => {
    const { rightsholderUserStore, uiStore } = useContext(StoresContext)
    const [sidebarIsOpen, setSidebarIsOpen] = useState<boolean>(false)

    useEffect(() => {
        analyticsSendPage('rightsholder_user_permissions_profile')
        return () => {
            rightsholderUserStore.destroyRightsHolderUsers()
        }
    }, [])

    const isMobile = uiStore.isMobile

    return (
        <>
            <title>User Permissions</title>
            <div className="rightsholder-maintenance-user-permissions-wrapper">
                <ContentHeader title="User Permissions" descriptionElement={<UserPermissionsContentHeader />}>
                    <Button
                        onClick={() => setSidebarIsOpen(true)}
                        mainColor
                        type="primary"
                        icon={ICONS.add}
                        className="add-user-button"
                    >
                        Add User
                    </Button>
                </ContentHeader>

                {isMobile && <MaintenanceMobileSubLinks />}
                <RightsholderUserPermissionsUsersList />

                <ModalPortal isOpen={sidebarIsOpen} onClose={() => setSidebarIsOpen(false)}>
                    <Sidebar onClose={() => setSidebarIsOpen(false)}>
                        <AddNewUserSub />
                    </Sidebar>
                </ModalPortal>
            </div>
        </>
    )
}

export default observer(RightsholderMaintenanceUserPermissions)
